/* global globalThis */

import axios from 'axios';
import { API_URL, getAuthConfig, parseApiError } from './api';

export async function gcoinRequest(token, path, { method = 'GET', data, signal } = {}) {
    try {
        const response = await axios({ url: `${API_URL}/api/finance/gcoin/${path}`,
            method, data, signal, timeout: 30000, ...getAuthConfig(token) });
        return response.data;
    } catch (cause) {
        if (axios.isCancel(cause)) throw cause;
        const status = cause.response?.status || 0;
        const error = new Error(parseApiError(cause.response?.data, 'Нет ответа сервера. Повтори тот же запрос.'));
        error.status = status;
        error.uncertain = !status || status >= 500 || status === 401 || status === 403;
        throw error;
    }
}

export async function gcoinEmployees(token, signal) {
    const response = await axios.get(`${API_URL}/api/employees/`, {
        ...getAuthConfig(token), signal, params: { role: 'can_have_orders', status: 'active' }, timeout: 30000,
    });
    if (!Array.isArray(response.data)) throw new Error('Сервер вернул некорректный список сотрудников.');
    return response.data.filter(a => !a.is_blocked && !a.is_fired && !a.trashed_at && !a.is_excluded_from_payroll);
}

export function gcoinRequestId() {
    if (globalThis.crypto?.randomUUID) return globalThis.crypto.randomUUID();
    if (!globalThis.crypto?.getRandomValues) throw new Error('Для операции нужен HTTPS и современный браузер.');
    const bytes = globalThis.crypto.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6] & 15) | 64; bytes[8] = (bytes[8] & 63) | 128;
    const hex = Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0,8)}-${hex.slice(8,12)}-${hex.slice(12,16)}-${hex.slice(16,20)}-${hex.slice(20)}`;
}

// Форматирование строкой: большие остатки не теряют точность из-за Number.
export function coinText(value) {
    if (value === null || value === undefined) return '—';
    const match = /^(-?)(\d+)(?:\.(\d+))?$/.exec(String(value));
    if (!match) return '—';
    const fraction = (match[3] || '').replace(/0+$/, '');
    return `${match[1]}${match[2].replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}${fraction ? `,${fraction}` : ''}`;
}

export function gcoinDate(value) {
    return value ? new Intl.DateTimeFormat('ru-RU', { dateStyle: 'short', timeStyle: 'short', timeZone: 'Europe/Moscow' }).format(new Date(value)) : '—';
}